import { Session } from './storage'

const SUBMITTED_CASES_KEY = 'submittedCaseTypes'

function getSubmittedCases() {
  const raw = Session.get(SUBMITTED_CASES_KEY)
  if (!raw) return []
  try {
    return JSON.parse(raw)
  } catch {
    return []
  }
}

export function isCaseSubmitted(serviceType) {
  return getSubmittedCases().includes(serviceType)
}

export function markCaseSubmitted(serviceType) {
  const list = getSubmittedCases()
  if (!list.includes(serviceType)) {
    list.push(serviceType)
    Session.set(SUBMITTED_CASES_KEY, list)
  }
}

export function getSolutionUrl(serviceType) {
  let name = ''
  let url = ''
  switch (serviceType) {
    case 'hxrl':
      name = '核心人力资源管理'
      url = 'core-hr-management-solution'
      break
    case 'gbgl':
      name = '干部管理'
      url = 'cadre-management-solution'
      break
    case 'rcpy':
      name = '人才管理'
      url = 'talent-development-solution'
      break
    case 'qyjx':
      name = '全员绩效管理'
      url = 'full-performance-management-solution'
      break
    case 'nzkh':
      name = '360考核'
      url = 'assessment-360-solution'
      break
    case 'zcps':
      name = '职称评审'
      url = 'title-review-solution'
      break
    case 'thpy':
      name = '同行评议'
      url = 'peer-review-solution'
      break
    case 'mzcp':
      name = '民主测评'
      url = 'democratic-evaluation-solution'
      break
    case 'mztj':
      name = '民主推荐'
      url = 'democratic-recommendation-solution'
      break
    case 'ldl':
      name = '领导力评估'
      url = 'leadership-assessment-solution'
      break
    case 'zxxx':
      name = '在线学习与在线考试'
      url = 'online-learning-exam-solution'
      break
    case 'rcpd':
      name = '人才盘点'
      url = 'talent-inventory-solution'
      break
    case 'rcdt':
      name = '人才地图'
      url = 'talent-map-solution'
      break
    case 'rqkh':
      name = '经理层任期制考核'
      url = 'manager-tenure-assessment-solution'
      break
    case 'jszj':
      name = '技术解决方案'
      url = 'security-technology-solution'
      break
    default:
      url = ''
      break
  }
  return {
    url: '/platform/homepage/solution/' + url + '.pdf',
    fileName: name + '.pdf'
  }
}

export function downloadSolutionPdf(serviceType) {
  const { url, fileName } = getSolutionUrl(serviceType)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export function handleGetSolution(vm, serviceType) {
  if (isCaseSubmitted(serviceType)) {
    downloadSolutionPdf(serviceType)
    return
  }
  vm.$store.state.infoDialogVisible = true
  vm.$store.state.infoDialogServiceType = serviceType
}
